export default {
    'diagram4-1-3': {
        's': 'S = Open plan office sought to boost communication and efficiency, deemphasize status',
        's-a': 'S = Did A to get B',
        'c': 'C = Study showed that employees disliked it on every aspect measured',
        'c-a': 'C = Caused Problem',
        'q': 'Q = (How respond?)',
        'q-a': 'Q= How fix?',
        'a': 'A = Restored privacy'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/4/4a/diagram3/i18n/en.js